import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {routerCompanyIdAtom} from "./routerStore";
import {getCompanyResultsLayers} from "../services/resultsService";
import {activeDateAtom, splitViewDateAtom} from "./activeDateStore";

export const activeCompanyResultsLayersAtom = atomWithRefresh(async (get) => {
    const activeCompanyId = get(routerCompanyIdAtom);
    const activeDate = await get(activeDateAtom);

    return activeCompanyId !== undefined && activeDate !== null
        ? await getCompanyResultsLayers(activeCompanyId, activeDate.format("YYYY-MM-DD"))
        : {};
});

export const activeCompanyResultsLayersLoadable = loadable(activeCompanyResultsLayersAtom);

export const activeCompanySplitViewResultsLayersAtom = atomWithRefresh(async (get) => {
    const activeCompanyId = get(routerCompanyIdAtom);
    const splitViewDate = await get(splitViewDateAtom);

    return activeCompanyId !== undefined && splitViewDate !== null
        ? await getCompanyResultsLayers(activeCompanyId, splitViewDate.format("YYYY-MM-DD"))
        : {};
});

export const activeCompanySplitViewResultsLayersLoadable = loadable(activeCompanySplitViewResultsLayersAtom);
